import { ScrollArea } from './ui/scroll-area';
import { Button } from './ui/button';
import { useCategories } from '../context/CategoryContext'; // useCategories 훅 임포트

interface CategoryFilterProps {
  selectedCategory: string;
  handleCategoryChange: (category: string) => void;
}

/**
 * 카테고리 필터
 *
 * - 설문의 카테고리를 정리한 필터
 *
 * @author hjkim
 * @constructor
 */
const CategoryFilter = ({ selectedCategory, handleCategoryChange }: CategoryFilterProps) => {
  const { categories, isLoading, isError, error } = useCategories(); // useCategories 훅 사용

  if (isLoading) {
    return <div>카테고리 불러오는 중...</div>;
  }

  if (isError) {
    return <div>오류: {error?.message || '카테고리 목록을 불러오는 데 실패했습니다.'}</div>;
  }

  return (
    <div className="py-3 ml-2">
      <div className="max-w-6xl mx-auto">
        <ScrollArea className="w-full">
          <div className="flex gap-2 pb-2 min-w-max">
            {categories.map((category) => (
              <Button
                key={category.id}
                variant={selectedCategory === category.id.toString() ? 'default' : 'ghost'} // id를 string으로 변환하여 비교
                className="cursor-pointer whitespace-nowrap flex items-center gap-1 px-3 py-2 text-xs sm:text-sm h-auto touch-manipulation"
                onClick={() => handleCategoryChange(category.id.toString())}>
                <span>{category.categoryEmoji}</span>
                <span className="hidden xs:inline sm:inline">{category.categoryNameKr}</span>
              </Button>
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};

export default CategoryFilter;
